var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table-column',{attrs:{"label":_vm.colConfig.label},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
return _c('div',{},[_c('text-button',{attrs:{"button-type":"primary"},on:{"click":function($event){_vm.handleBrowse(row)}}},[_vm._v("\n      "+_vm._s(_vm.$t('general.browse'))+"\n    ")]),_vm._v(" "),_c('text-button',{attrs:{"button-type":"primary"},on:{"click":function($event){_vm.triggerKGTest(row)}}},[_vm._v("\n      "+_vm._s(_vm.$t('knowledge_graph.material_manage.test'))+"\n    ")])],1)}}])})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7370a78","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/KnowledgeGraph/_components/OperationColumn.vue
// module id = null
// module chunks = 